import type React from 'react';
import { useWordsHappenTheme } from '../../theme';
import styles from './form-alert.module.scss';

export interface WordsHappenFormAlertProps {
  /** Optional bold lead-in, e.g. "Couldn't sign you in". */
  title?: React.ReactNode;
  /** The message. */
  children: React.ReactNode;
  id?: string;
  className?: string;
}

/**
 * A form-level error message on a coral wash, with role="alert" so it is read out as soon as it is shown.
 * Render it only while there is an error.
 */
export const WordsHappenFormAlert: React.FC<WordsHappenFormAlertProps> = ({ title, children, id, className }) => {
  const { theme } = useWordsHappenTheme();

  const cls = [styles.alert, theme === 'meadow' ? styles.meadow : styles.flat, className].filter(Boolean).join(' ');

  return (
    <div id={id} role="alert" className={cls}>
      {title && <strong className={styles.title}>{title}</strong>}
      <span className={styles.message}>{children}</span>
    </div>
  );
};
